<template>
  <div class="propriedades_particula row">
    <div id="conteudo_propriedades_particula">
      <div class="form-group">
        <label for="Raio">Raio:</label>
        <input
          type="number"
          class="form-control"
          id="Raio"
          aria-describedby="emailHelp"
          placeholder="Raio: a (pw)"
        />
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Permissividade (ε / ε0)</label>
        <div class="form-row">
          <div class="col s6">
            <input
              type="number"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Real"
            />
          </div>
          <div class="col s6">
            <input
              type="number"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="descobrir o que está escrito"
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Permeabilidade (ϒ / ϒ0)</label>
        <div class="row">
          <div class="col s6">
            <input
              type="number"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder
            />
          </div>
          <div class="col s6">
            <input
              type="number"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "propriedadesParticula"
};
</script>